import {Module} from "vuex";
import {RootState} from "@/store/types";
import { callStatistic } from "./statistic";
import { callSound } from "./sound";

export const callModule: Module<any, RootState> = {
  modules: {
    callStatistic,
    callSound,
    // callTemplate,
    // callFilter,
  }
}